const fetched: Record<string, boolean> = {};

export function isFetched(src: string | null | undefined) {
  return src ? fetched[src] : false;
}

export function fetchImage(src: string) {
  if (isFetched(src)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    const onload = () => {
      fetched[src] = true;
      resolve(void 0);
    };
    img.onerror = reject;
    img.onload = onload;
    img.src = src;
  });
}
